import React, { createContext, useCallback, useContext, useReducer } from 'react';

const defaultTemplateCreationSidePanelState = {
  open: false,
  onSuccess: null,
  isSample: false,
  onCancel: null,
  templateId: null,
};

const TemplateCreationSidepanelContext = createContext(defaultTemplateCreationSidePanelState);

const actions = {
  SHOW_SIDEPANEL: 'SHOW_SIDEPANEL',
  HIDE_SIDEPANEL: 'HIDE_SIDEPANEL',
};

const actionsReducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case actions.SHOW_SIDEPANEL:
      return {
        open: true,
        onSuccess: payload.onSuccess,
        isSample: payload.isSample,
        onCancel: payload.onCancel,
        templateId: payload.templateId,
      };

    case actions.HIDE_SIDEPANEL:
      return defaultTemplateCreationSidePanelState;

    default:
      return state;
  }
};

export const TemplateCreationSidePanelProvider = ({ children }) => {
  const [state, dispatch] = useReducer(actionsReducer, defaultTemplateCreationSidePanelState);

  const showSidepanel = useCallback(({ onSuccess, isSample, onCancel, templateId }) => {
    dispatch({
      type: actions.SHOW_SIDEPANEL,
      payload: { onSuccess, isSample, onCancel, templateId },
    });
  }, []);

  const hideSidepanel = useCallback(() => {
    dispatch({
      type: actions.HIDE_SIDEPANEL,
    });
  }, []);

  return (
    <TemplateCreationSidepanelContext.Provider
      value={{
        state,
        showSidepanel,
        hideSidepanel,
      }}
    >
      {children}
    </TemplateCreationSidepanelContext.Provider>
  );
};

export const useTemplateCreationSidePanel = () => useContext(TemplateCreationSidepanelContext);
